import { Button, Icon } from '@testsigma/atoms';
import TestsigmaFolder from '@images/testsigma-folder.svg';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { PageLoader } from '@utils/common';


const DownloadFromLinkComponent = () => {
    const navigate = useNavigate();
    const navigateHome = () => {
        navigate('/dashboard');
    };
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        setIsLoading(true);
        retryDownload();
        setTimeout(() => {
            setIsLoading(false);
        }, 3000);
    }, []);


    function transformToPrivateUrl(url: string): string {
        if (!url)
            return url;
        // Step 1: Replace /ui/ with /private/
        let updatedUrl = url.replace('/ui/', '/private/');
        return updatedUrl;
    }

    function retryDownload() {
        const downloadURL = transformToPrivateUrl(window.location.href);
        window.location.href = downloadURL;
    }

    return (
        <>
        {isLoading ? <PageLoader/>:
        <div className='flex justify-center w-full h-full'>
            <div className='w-2/4 h-11/12 flex flex-col justify-center'>
                <div className='flex justify-center '>
                    <img src={TestsigmaFolder} alt='Download Initiated...' />
                </div>

                <div className=' font-semibold flex justify-center pt-6'>
                    {__('file.download.success.title')}
                </div>
                <div className='text-secondary-500 text-center font-normal text-sm pt-4'>
                    {__('file.download.success.message')}
                </div>
                <div className='flex flex-col mt-8 items-center justify-center w-full'>
                    <Button onClick={retryDownload} className='w-fit'>
                        {__('file.download.retry.button')}
                    </Button>
                    <Button onClick={navigateHome} className='mt-4 w-fit'>
                        {__('common.go_to_testsigma.label')}
                        <Icon name='open-in-new' className='text-xl ml-2' />
                    </Button>
                </div>
            </div>
            <div
                className='absolute bottom-8 flex justify-center text-2xs text-secondary-500'
                dangerouslySetInnerHTML={{
                    __html: __('common.error_boundary_footer_text'),
                }}
            />
        </div>
}
        </>
    );
};

export default DownloadFromLinkComponent;
